import EventBus from './../wirebox/event-bus'

EventBus.subscribe('loading.start', (element) => {
    element.addClass('loading')
}).subscribe('loading.stop', (element) => {
    element.removeClass('loading')
})